/*
  Shoes Egy — Latin digits in the quantity field.

  Chrome renders <input type="number"> using the BROWSER's locale, not the
  page's, so an Egyptian shopper with an Arabic UI sees "١" however the document
  or the element is tagged. lang="en" does not fix it, and neither does
  font-variant-numeric: those select glyph variants within a script, they do not
  change the script.

  The field is therefore type="text" inputmode="numeric" in main-product.liquid,
  which renders the literal characters. Dawn's QuantityInput drives the +/-
  buttons with input.stepUp() / stepDown(), which only exist on type="number" —
  so give this element its own copies. Defining them as own properties means
  Dawn's code keeps calling exactly what it called before, and global.js is not
  touched.
*/
(function () {
  function shim(input) {
    if (!input || input.dataset.shoesQtyShim) return;
    input.dataset.shoesQtyShim = '1';

    var attr = function (name) {
      var raw = input.getAttribute(name);
      if (raw === null || raw === '') return null;
      var n = parseInt(raw, 10);
      return isNaN(n) ? null : n;
    };

    var clamp = function (value) {
      var lo = attr('min');
      var hi = attr('max');
      if (lo !== null && value < lo) value = lo;
      if (hi !== null && value > hi) value = hi;
      return value;
    };

    var step = function (direction) {
      var by = attr('step') || 1;
      var current = parseInt(input.value, 10);
      if (isNaN(current)) current = attr('min') || 0;
      input.value = String(clamp(current + direction * by));
    };

    input.stepUp = function () {
      step(1);
    };
    input.stepDown = function () {
      step(-1);
    };
  }

  function run() {
    document.querySelectorAll('input.quantity__input[type="text"]').forEach(shim);
  }

  run();
  document.addEventListener('DOMContentLoaded', run);

  // Dawn replaces the buy area wholesale when the variant changes
  if (window.MutationObserver) {
    var scheduled = false;
    new MutationObserver(function () {
      if (scheduled) return;
      scheduled = true;
      window.requestAnimationFrame(function () {
        scheduled = false;
        run();
      });
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
})();
